import image1 from "./../images/icon/icon-paper-stack-white-alpha-2kb.png";
import image2 from "./../images/icon/icon-statements-white.png";
import image3 from "./../images/icon/icon-money-fast-white-alpha.png";
import image4 from "./../images/icon/icon-reconciliations-white.png";
import image5 from "./../images/icon/icon-shield-checked-white.png";
import image6 from "./../images/icon/icon-research-white.png";
import image7 from "./../images/icon/icon-new-account-w-v2.png";
import image8 from "./../images/icon/icon-stoppayment-white.png";
import image9 from "./../images/icon/icon-accounting-white-v2.png";

const ImageArray = [
  { id: 1, src: image1 },
  { id: 2, src: image2 },
  { id: 3, src: image3 },
  { id: 4, src: image4 },
  { id: 5, src: image5 },
  { id: 6, src: image6 },
  { id: 7, src: image7 },
  { id: 8, src: image8 },
  { id: 9, src: image9 }
];

function IconSet() {
  return ImageArray;
}

export default IconSet;
